import { useEffect } from "react";
import { ApiKeysCard } from "./card";
import { ApiKeysNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { ApiKeysTable } from "./table";

export default function ApiKeys() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Clés API");
  }, []);

  return (
    <Routes>
      <Route index element={<ApiKeysTable />} />
      <Route path="/new" element={<ApiKeysNew />} />
      <Route path=":id" element={<ApiKeysCard />} />
    </Routes>
  );
}
